import React from 'react';
import { createUseStyles } from 'react-jss';
import PropTypes from 'prop-types';

const useStyles = createUseStyles({
  flexWrap: {
    display: 'flex',
    flexGrow: 1,
  },
});

const FlexWrap = ({ children }) => {
  const classes = useStyles();
  return <div className={classes.flexWrap}>{children}</div>;
};

FlexWrap.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FlexWrap;
